import React, {ReactNode} from 'react';
import {NavItem, NavLink, Button} from 'reactstrap';
import CmsComponent from '@episerver/spa-core/Components/CmsComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MenuBusinessItemBlockData from 'app/Models/Content/MenuItemBlockData';
import Config from '../../Config';

interface MenuBusinessItemBlockState {
  linkTarget: string;
  show: boolean;
}

export default class MenuBusinessItemBlock extends EpiComponent<MenuBusinessItemBlockData, MenuBusinessItemBlockState> {
  protected getInitialState(): MenuBusinessItemBlockState {
    return {
      linkTarget: this.props.data.link.value !== null ? this.props.data.link.value : '#',
      show: false,
    };
  }

  public componentDidUpdate() {
    if (this.props.data.link !== null) {
      let newLinkTarget: string = this.props.data.link.value !== null ? this.props.data.link.value : '#';

      if (this.props.data.link && this.state.linkTarget !== newLinkTarget) {
        this.setState({
          linkTarget: this.props.data.link.value !== null ? this.props.data.link.value : '#',
        });
      }
    }
  }
  public onButtonClick(event: MouseEvent) {
    this.navigateTo(this.props.data.link.value);

    event.preventDefault();
    return false;
  }

  public render(): ReactNode {
    const currentPath = this.props.context.getStore().getState()?.ViewContext?.currentPath;
    const isSelected = this.state.linkTarget == currentPath;

    let dropdownButton: ReactNode = null;
    {
      dropdownButton = (
        <Button color='primary' size='lg' block onClick={this.onButtonClick.bind(this)}>
          {this.props.data.link.value}
        </Button>
      );
    }

    return (
      <NavItem>
        <div className={`__menu-item-container ${isSelected ? 'selected' : ''}`}>
          <div className='__title-text'>
            <NavLink
              style={{
                backgroundImage: this.props.data.menuImage?.value
                  ? `url(${Config.epiBaseUrl + this.props.data.menuImage?.value?.url})`
                  : '',
              }}
              href={this.state.linkTarget}
              active={this.state.linkTarget == this.props.path}
              eventkey={this.props.data.name}
              arial-label={this.props.data.ariaLabelText?.value}>
              <span className={`${this.props.data.menuImage?.value ? 'item-with-image' : ''}`}>{this.props.data.name.value}</span>
            </NavLink>
          </div>
        </div>
      </NavItem>
    );
  }
}
